import * as yup from 'yup';

export const addSuggestionValidation = yup.object().shape({
  text: yup.string().required('Suggestion description is required'),
});
